import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { DICTS } from "@/lib/i18n";

export const Route = createFileRoute("/account/coupons")({
  component: lazyRouteComponent(() => import("./-pages/account.coupons")),
  head: () => ({
    meta: [
      { title: DICTS.en["account.coupons.meta_title"] ?? "My coupons" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
});
